"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_INDEX_ROW_HIGHLIGHT_ATTRIBUTE = exports.FILE_INDEX_SOURCE_HIGHLIGHT_CLASS = exports.FILE_INDEX_HIGHLIGHT_SCOPES = exports.FILE_INDEX_HIGHLIGHT_EVENTS = exports.FILE_INDEX_DATABASE_PROTECTION_PROPS = exports.FILE_INDEX_COLUMN_IDS = exports.FILE_INDEX_COLUMNS = exports.FILE_INDEX_ROW_ID_PREFIX = exports.FILE_INDEX_DATABASE_ID_PREFIX = exports.FILE_INDEX_MANAGED_BY = void 0;
exports.isFileIndexDatabaseId = isFileIndexDatabaseId;
exports.decodeFileIndexRowSourceBlockId = decodeFileIndexRowSourceBlockId;
exports.isFileIndexSystemColumnId = isFileIndexSystemColumnId;
exports.isFileIndexManagedColumnData = isFileIndexManagedColumnData;
exports.normalizeAttachmentCell = normalizeAttachmentCell;
exports.FILE_INDEX_MANAGED_BY = 'file-index';
exports.FILE_INDEX_DATABASE_ID_PREFIX = 'file-index';
exports.FILE_INDEX_ROW_ID_PREFIX = 'file-index-row-';
exports.FILE_INDEX_COLUMNS = {
    sourceBlockId: 'file-source-block-id',
    blobId: 'file-blob-id',
    mime: 'file-mime',
    size: 'file-size',
    kind: 'file-kind',
    extension: 'file-extension',
};
exports.FILE_INDEX_COLUMN_IDS = Object.values(exports.FILE_INDEX_COLUMNS);
function isFileIndexDatabaseId(databaseId) {
    return (typeof databaseId === 'string' &&
        databaseId.startsWith(`${exports.FILE_INDEX_DATABASE_ID_PREFIX}-`));
}
function decodeFileIndexRowSourceBlockId(rowId) {
    if (typeof rowId !== 'string' ||
        !rowId.startsWith(exports.FILE_INDEX_ROW_ID_PREFIX)) {
        return undefined;
    }
    const encoded = rowId.slice(exports.FILE_INDEX_ROW_ID_PREFIX.length);
    if (!encoded || encoded.length % 2 !== 0 || /[^0-9a-f]/i.test(encoded)) {
        return undefined;
    }
    let decoded = '';
    for (let index = 0; index < encoded.length; index += 2) {
        decoded += String.fromCharCode(Number.parseInt(encoded.slice(index, index + 2), 16));
    }
    return decoded || undefined;
}
function isFileIndexSystemColumnId(columnId) {
    return (columnId === 'title' ||
        exports.FILE_INDEX_COLUMN_IDS.includes(columnId));
}
function isFileIndexManagedColumnData(data) {
    return (data?.managedBy === exports.FILE_INDEX_MANAGED_BY || data?.systemManaged === true);
}
exports.FILE_INDEX_DATABASE_PROTECTION_PROPS = {
    managedBy: exports.FILE_INDEX_MANAGED_BY,
    systemManaged: true,
    docScoped: true,
};
exports.FILE_INDEX_HIGHLIGHT_EVENTS = {
    rowSourceHighlightChange: 'streamlain:file-index-row-source-highlight-change',
    sourceElementHighlightChange: 'streamlain:file-index-source-element-highlight-change',
};
exports.FILE_INDEX_HIGHLIGHT_SCOPES = {
    rowSelection: 'file-index-row-selection',
    rowHover: 'file-index-row-hover',
};
exports.FILE_INDEX_SOURCE_HIGHLIGHT_CLASS = 'streamlain-file-index-source-highlight';
exports.FILE_INDEX_ROW_HIGHLIGHT_ATTRIBUTE = 'data-streamlain-file-index-row-highlighted';
function isObject(value) {
    return value != null && typeof value === 'object' && !Array.isArray(value);
}
function toNullableNumber(value) {
    return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
function normalizeAttachmentFile(rawFile, fallbackBlobId) {
    if (!isObject(rawFile))
        return null;
    const rawBlobId = rawFile.blobId ?? rawFile.id ?? fallbackBlobId;
    const blobId = typeof rawBlobId === 'string' ? rawBlobId.trim() : '';
    if (!blobId)
        return null;
    const rawName = rawFile.name ?? rawFile.filename;
    const name = typeof rawName === 'string' ? rawName : blobId;
    const rawMime = rawFile.mime ?? rawFile.type ?? rawFile.mediaType;
    const mime = typeof rawMime === 'string' ? rawMime : '';
    return {
        blobId,
        id: blobId,
        mime,
        name,
        size: toNullableNumber(rawFile.size),
    };
}
function normalizeAttachmentCell(value) {
    const files = [];
    if (Array.isArray(value)) {
        files.push(...value.flatMap(file => normalizeAttachmentFile(file) ?? []));
    }
    else if (isObject(value)) {
        if (isObject(value.value) || Array.isArray(value.value)) {
            return normalizeAttachmentCell(value.value);
        }
        else if (Array.isArray(value.files)) {
            files.push(...value.files.flatMap(file => normalizeAttachmentFile(file) ?? []));
        }
        else {
            files.push(...Object.entries(value).flatMap(([blobId, rawFile]) => normalizeAttachmentFile(rawFile, blobId) ?? []));
        }
    }
    return {
        blobIds: files.map(file => file.blobId),
        count: files.length,
        filenames: files.map(file => file.name),
        files,
        isEmpty: files.length === 0,
        mimeTypes: files.map(file => file.mime).filter(Boolean),
    };
}
